import { useState, useRef, useEffect } from 'react';

export const useCarouselScroll = (articles, clarityPickIndex) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [hasOverflow, setHasOverflow] = useState(false);
  const scrollContainerRef = useRef(null);

  // Start the carousel on Clarity's Pick (middle card, stances on left/right) - once per mount
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (articles.length > 1 && container) {
      const cardWidth = container.querySelector('[data-card]')?.offsetWidth || 0;
      const gap = window.innerWidth < 640 ? 12 : 16;
      container.scrollTo({ left: clarityPickIndex * (cardWidth + gap), behavior: 'auto' });
      setCurrentIndex(clarityPickIndex);
    }
    const checkOverflow = () => {
      if (scrollContainerRef.current) {
        const c = scrollContainerRef.current;
        setHasOverflow(c.scrollWidth > c.clientWidth + 4);
      }
    };
    checkOverflow();
    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, []);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 640);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const scrollToIndex = (index) => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const cardWidth = container.querySelector('[data-card]')?.offsetWidth || 0;
      const gap = isMobile ? 12 : 16;
      container.scrollTo({ left: index * (cardWidth + gap), behavior: 'smooth' });
    }
    setCurrentIndex(index);
  };

  const goToPrevious = (e) => {
    e.preventDefault();
    e.stopPropagation();
    scrollToIndex(currentIndex === 0 ? articles.length - 1 : currentIndex - 1);
  };

  const goToNext = (e) => {
    e.preventDefault();
    e.stopPropagation();
    scrollToIndex(currentIndex === articles.length - 1 ? 0 : currentIndex + 1);
  };

  const handleScroll = (e) => {
    if (!isMobile) return;
    const container = e.target;
    const cardWidth = container.querySelector('[data-card]')?.offsetWidth || 0;
    const newIndex = Math.round(container.scrollLeft / (cardWidth + 12));
    if (newIndex !== currentIndex && newIndex >= 0 && newIndex < articles.length) {
      setCurrentIndex(newIndex);
    }
  };

  return { scrollContainerRef, currentIndex, isMobile, hasOverflow, scrollToIndex, goToPrevious, goToNext, handleScroll };
};
